import {BaseQueryArg, createApi, EndpointBuilder, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {queries} from "../../Infrastructure/const/queries";


export const categoryAPI = createApi({
    reducerPath: 'categoryAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: queries.baseURL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('userToken');

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),


    endpoints: (build) => ({
        fetchAllCategories: build.query ({
            query: () => ({
                url: queries.getCategories,
                method: 'GET',
            })
        }),
    })
})